import { answearDao } from '@/service';

export default {
  state: {
    forgotpswdModal: false,
  },
  mutations: {
    SET_FORGOTPSWD_MODAL(state, payload) {
      state.forgotpswdModal = payload;
    },
  },
  actions: {
    getAllAnswears(_, payload) {
      return new Promise((resolve, reject) => {
        answearDao
          .getAll(payload)
          .then((resp) => {
            resolve(resp.data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAnswear(_, payload) {
      return new Promise((resolve, reject) => {
        answearDao
          .get(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveAnswear(_, payload) {
      return new Promise((resolve, reject) => {
        answearDao
          .insert(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAnswear(_, payload) {
      return new Promise((resolve, reject) => {
        answearDao
          .update(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeAnswear(_, payload) {
      return new Promise((resolve, reject) => {
        answearDao
          .remove(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  getters: {},
};
